import React, { PropsWithChildren } from 'react';

import { Sx, useSx } from '@lib/hooks/useShorthandStyles';

type StickyProps = PropsWithChildren<{
    top: number;
    sx?: Sx;
}>;

const Sticky: React.FC<StickyProps> = ({ top, sx, children }) => {
    const style = useSx(sx ?? {}) as React.CSSProperties;

    return (
        <div
            style={{
                width: '100%',
                position: 'sticky',
                zIndex: 100,
                top,
                ...style
            }}
        >
            {children}
        </div>
    );
};
export default Sticky;
